import React, { createContext, useContext, useState, useCallback } from "react";

const EnquiryContext = createContext(null);

export function EnquiryProvider({ children }) {
  const [state, setState] = useState({ open: false, mode: "consultation", source: "" });

  const openEnquiry = useCallback((mode = "consultation", source = "") => {
    setState({ open: true, mode, source });
  }, []);

  const closeEnquiry = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  return (
    <EnquiryContext.Provider value={{ ...state, openEnquiry, closeEnquiry }}>
      {children}
    </EnquiryContext.Provider>
  );
}

export function useEnquiry() {
  const ctx = useContext(EnquiryContext);
  if (!ctx) throw new Error("useEnquiry must be used within EnquiryProvider");
  return ctx;
}
